import { render, staticRenderFns } from "./chooseExpert.vue?vue&type=template&id=553041f3&scoped=true"
import script from "./chooseExpert.vue?vue&type=script&lang=js"
export * from "./chooseExpert.vue?vue&type=script&lang=js"
import style0 from "./chooseExpert.vue?vue&type=style&index=0&id=553041f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553041f3",
  null
  
)

export default component.exports